import('./scss/main.scss');